var React = require('react');

function IconAudios (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Tracé_733","data-name":"Tracé 733","d":"M4.256.009A4.244,4.244,0,0,1,8.494,4.26V9.219a4.238,4.238,0,1,1-8.476,0V4.258A4.244,4.244,0,0,1,4.256.009Z","transform":"translate(-0.017 6.552) rotate(-1)","fill":"#000000","key":0}),React.createElement("path",{"id":"Tracé_734","data-name":"Tracé 734","d":"M.025,12.454C-.131,18,6.54,21.879,9.489,23.1s8.067,4.214,9.465-1.219.157-17.3.157-17.3S18.181-2.4,10.733.925.18,6.91.025,12.454Z","transform":"translate(9.712 0.315) rotate(-1)","fill":"#000000","key":1})]);
}

IconAudios.defaultProps = {"id":"AUDIOS-INACTIF","width":"29.764","height":"25.337","viewBox":"0 0 29.764 25.337"};

module.exports = IconAudios;

IconAudios.default = IconAudios;
